module.exports = __webpack_public_path__ + "img/madeo-tm_0.4f41059a.jpg";